import type { ICity, ICountry, IState } from 'country-state-city';

export interface BpicLocation {
	city: string;
	state: string;
	country: string;
	countryCode: string;
	placeId: string;
}

/**
 * Build the stored BpicLocation JSON from a country-state-city `City` record.
 * `country`/`state` are resolved by the caller (which owns the loaded dataset) so
 * this module stays free of any runtime `country-state-city` import.
 */
export const mutateCityToBpicLocationFormat = (city: ICity, country?: ICountry, state?: IState): string => {
	const location: BpicLocation = {
		city: city.name,
		state: state?.name ?? '',
		country: country?.name ?? '',
		countryCode: city.countryCode,
		placeId: '',
	};

	return JSON.stringify(location);
};

/**
 * Build a BpicLocation JSON from free-typed text — the fallback for towns not in
 * the dataset (react-bootstrap-typeahead `allowNew`).
 */
export const mutateFreeTextToBpicLocationFormat = (text: string): string => {
	const location: BpicLocation = {
		city: text.trim(),
		state: '',
		country: '',
		countryCode: '',
		placeId: '',
	};

	return JSON.stringify(location);
};

export const mutateBpicLocationFormatToInputFormat = (locationString: string): string => {
	try {
		const parsedLocation: BpicLocation = JSON.parse(locationString);
		let locationInputValue = parsedLocation.city;

		if (parsedLocation.state?.length) {
			locationInputValue += ', ' + parsedLocation.state;
		}

		if (parsedLocation.country?.length) {
			locationInputValue += ', ' + parsedLocation.country;
		}

		return locationInputValue;
	} catch (error) {
		return '';
	}
};
